// source: https://stackoverflow.com/questions/67550204/typing-pipe-compose-function-that-uses-reduceright-with-generics
/* eslint-disable @typescript-eslint/no-explicit-any */
type Func = (...args) => any;
type Noop = () => void;
const noop: Noop = () => {};

export function composeFunctions(): Noop;
export function composeFunctions<T extends Func>(fn: T): T;
export function composeFunctions<T extends Func, U extends Func[], R extends Func>(...fns: [T, ...U, R]): (...args: Parameters<T>) => ReturnType<R>;
export function composeFunctions(...fns: any) {
    if (fns.length === 0) return noop;
    if (fns.length === 1) return fns[0];
    return fns.reduce((f: any, g: any) =>
      (...args: any) => g(f(...args))
    );
}


/* eslint-disable @typescript-eslint/no-explicit-any */
//source: https://minaluke.medium.com/typescript-compose-function-b7512a7cc012
type PickLastInTuple<T extends any[]> = T extends [...rest: infer U, argn: infer L ] ? L : never;
type FirstFnParameterType<T extends any[]> = Parameters<PickLastInTuple<T>>[any];
type LastFnReturnType<T extends any[]> = ReturnType<T[0]>;

type ArityOneFn = (arg: any) => any;
export const composeUniFunction = <T extends ArityOneFn[]>(...fns: T) =>
  (p: FirstFnParameterType<T>): LastFnReturnType<T> =>
    fns.reduceRight((acc: any, cur: any) => cur(acc), p);

type ArityTwoFn = (arg: any) => any;
export const composeBiFunction = <T extends ArityTwoFn[]>(...fns: T) =>
  (p: FirstFnParameterType<T>): LastFnReturnType<T> =>
    fns.reduceRight((acc: any, cur: any) => cur(acc), p);

/* eslint-enable @typescript-eslint/no-explicit-any */



/* eslint-disable @typescript-eslint/no-explicit-any */
// source: https://gist.github.com/ua9msn/dcb6ee5af756b33349640e734adaa3fe
type CF = (...args: any[]) => any;

// type LastFnReturnType<T extends any[]> = ReturnType<T[0]>;

export function composeFunctions2<T extends CF[]>(...fns: T) {
    return function (...args: any[]):LastFnReturnType<T> {
        // @ts-ignore
        return fns.reduceRight((acc, fn) => {
            return {...acc, ...fn(...args)};
        }, {} as LastFnReturnType<T>);
    };
}
/* eslint-enable @typescript-eslint/no-explicit-any */


//readmore: https://dev.to/ecyrbe/how-to-use-advanced-typescript-to-define-a-pipe-function-381h


export function composeFunctions3(...fncs){

    return fncs.reverse().reduce(
      (
        previousValue,
        currentValue,
      )=>{
          return async (params)=>{
              return await currentValue(params, previousValue);
          };
      },d=>d,
    );
}
